import {selectIsGuestsFabricGreetingCard} from '~/common/fabric/EventGuests/reducers/guests/selectors';
import {PLAN_NAME_PARTY_PASS, PLAN_NAME_PRO} from '~/common/fabric/routes/EventReview/constants';
import {isSubscriptionPlan} from '~/common/fabric/User/utils';

export const selectUser = (state) => state.user || {};
export const userIsLoggedIn = (state) => !!selectUser(state).isAuthenticated;
export const selectUserName = (state) => selectUser(state).userName;
export const isUserAuthenticated = (state) =>
  !!(selectUser(state).isAuthenticated || selectUser(state).is_authenticated);
export const selectIsHost = (state) => selectUser(state).isHost ?? false;
export const getLoggedUserId = (state) => selectUser(state).userId;
export const getGuestId = (state) => selectUser(state).guestId;
export const selectUserEmail = (state) => selectUser(state).email;
export const selectUserSha256 = (state) => selectUser(state).emailSha256;
export const selectUserFirstName = (state) => selectUser(state).firstName;
export const selectUserPhoneNumber = (state) => selectUser(state).phoneNumber || '';
export const selectVolunteerEmail = (state) => selectUser(state).volunteerEmail;
export const selectVolunteerName = (state) => selectUser(state).volunteerName;
export const selectIsProOrPartyPass = ({user}) =>
  user.subscriptionPlanName === PLAN_NAME_PRO || user.subscriptionPlanName === PLAN_NAME_PARTY_PASS;
export const selectSubscriptionPlanName = (state) => selectUser(state).subscriptionPlanName;
export const userHasSubscriptionPlan = (state) =>
  isSubscriptionPlan(selectSubscriptionPlanName(state), selectIsGuestsFabricGreetingCard(state));
export const selectSubscriptionEndDate = (state) => selectUser(state).subscriptionEndDate;
export const selectSubscriptionStatus = (state) => selectUser(state).subscriptionStatus;
